module.exports = __webpack_public_path__ + "static/media/cosultancy-services.7329ba9e.png";